import {BaseErrorBody} from './BaseError';

export const IAP_ERROR = Symbol();

export type IapError = {
  kind: typeof IAP_ERROR;
  code: string | number | undefined;
  message: string | undefined;
} & BaseErrorBody;
